<template>
    <div>
        <div>
            <div class="common-search">
                <el-date-picker
                        v-model="date"
                        format="yyyy-MM-dd HH:mm"
                        type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"/>

                <el-input
                        class="common-el-input"
                        placeholder="输入俱乐部ID查询"
                        v-model="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="searchClubRoomStats()">搜索</el-button>
                <el-button v-if="permissions.osm_room_info_export" type="success" @click="exportFunc">导出</el-button>
            </div>
        </div>

        <div>
            <strong class="common-text-item" v-text="`总带入：${clubRoomStats.totalBring}`"></strong>
            <strong class="common-text-item" v-text="`总保险池：${clubRoomStats.totalInsurance}`"></strong>
            <strong class="common-text-item" v-text="`总手数：${clubRoomStats.totalHands}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="clubRoomStats.beanList"
                    :row-key="row=>JSON.stringify(row)"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="俱乐部号" width="120" align="center" prop="clubRandomId"/>
                <el-table-column label="俱乐部名称" width="150" align="center" prop="clubName"/>
                <el-table-column label="房间ID" width="120" align="center" prop="roomId"/>
                <el-table-column label="房间名称" width="150" align="center" prop="roomName"/>
                <el-table-column label="是否开启保险" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.insurance?'是':'否'}}</template>
                </el-table-column>
                <el-table-column label="保险池" align="center" prop="insurancePool">
                  <template slot-scope="scope">{{scope.row.insurancePool|numberChip}}</template>
                </el-table-column>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" width="150" align="center" prop="userNickname"/>
                <el-table-column label="带入" align="center" prop="bring">
                  <template slot-scope="scope">{{scope.row.bring|numberChip}}</template>
                </el-table-column>
                <el-table-column label="盲注级别" align="center" prop="blind">
                  <template slot-scope="scope">{{scope.row.blind|blindNoteNumber}}</template>
                </el-table-column>
                <el-table-column label="手数" align="center" prop="hand"/>
                <el-table-column label="开始时间" width="150" align="center" prop="startTime"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :current-page="currentPage"
                :total="clubRoomStats.total"
                @current-change="searchClubRoomStats({page:$event})"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
                clubRoomStats: {// 俱乐部牌局信息
                    beanList: [],
                    total: 0,
                    totalBring: 0,// 总带入
                    totalInsurance: 0,// 总保险
                    totalHands: 0,// 总手数
                },
                currentPage: 1
            }
        },
        computed: {
            ...mapState('login', ['permissions']),
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('gameDetail', ['getClubRoomStats']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.searchVal) {
                    this.$message.error('请输入俱乐部ID');
                    return false
                }
                return true
            },
            searchClubRoomStats(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    clubRandomId: this.searchVal,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: 1,
                };
                Object.assign(params, obj);
                this.currentPage = params.page;
                this.getClubRoomStats(params).then(res => {
                    this.clubRoomStats = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/gameDetail/club/room/stats/export',
                    info: [
                        {name: 'clubRandomId', value: this.searchVal},
                        {name: 'startTime', value: this.date ? this.date[0] : ''},
                        {name: 'endTime', value: this.date ? this.date[1] : ''},
                    ]
                });
            }
        }
    }
</script>